import { Bullet, Grid, Inline, Text } from "@generalapplications/ui";

import {
  RevealGroup,
  RevealItem,
} from "@/app/common/components/composite/motion/RevealGroup";
import { formatText } from "@/app/common/functions/format/formatText";

export type EngineeringListProps = {
  items: readonly string[];
  ariaLabel: string;
};

// What has been engineered, as short noun phrases — deliberately the quietest
// list on the page.
//
// OfferingList and QuestionList both put their statements on cards. This list
// sits directly above the phase grid, which is already cards, so a third card
// treatment in a row would flatten the page into one texture. So it is a plain
// marked list: muted, no card. It also happens to be the right register —
// these are things that exist, and a name does not need a card around it to
// be believed.
export function EngineeringList({ items, ariaLabel }: EngineeringListProps) {
  return (
    <RevealGroup>
      <Grid
        as="ul"
        aria-label={ariaLabel}
        columns={{ base: 1, lg: 2 }}
        gap="md"
      >
        {items.map((item) => (
          <RevealItem as="li" key={item}>
            <Inline align="start" gap="sm">
              <Bullet />
              <Text variant="prose">{formatText(item)}</Text>
            </Inline>
          </RevealItem>
        ))}
      </Grid>
    </RevealGroup>
  );
}
